module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#user",
      toString: function () {
        return this.url;
      }
    }